import ProfileEdit from './container';

export default ProfileEdit;



// WEBPACK FOOTER //
// ./src/routes/ProfileEdit/index.js